import { Button } from '@shared/components/ui/button';
import { Label } from '@shared/components/ui/label';
import { MultiSelect } from '@shared/components/ui/MultiSelect';
import { useTranslation } from 'react-i18next';
import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import { usePrintersFilters } from '../../hooks/usePrintersFilters';

interface PrintersFiltersPanelProps {
  initialConditions: FilterConditionOutput[];
  onChange: (conditions: FilterConditionOutput[]) => void;
}

export const PrintersFiltersPanel = ({ initialConditions, onChange }: PrintersFiltersPanelProps) => {
  const { t } = useTranslation('printersModule');
  const { filters, handleFilterChange, clearFilters } = usePrintersFilters({
    initialConditions,
    onChange,
  });

  const connectionOptions = [
    { label: t('status.online', 'Activa'), value: 'online' },
    { label: t('status.offline', 'Inactiva'), value: 'offline' },
  ];

  const statusOptions = [
    { label: t('status.enabled', 'Habilitada'), value: 'true' },
    { label: t('status.disabled', 'Deshabilitada'), value: 'false' },
  ];

  return (
    <div className="space-y-4 min-w-[300px]">
      {/* Connection Status */}
      <div className="space-y-2">
        <Label>{t('table.connection', 'Conexión')}</Label>
        <MultiSelect
          options={connectionOptions}
          value={filters.status}
          onValueChange={(val) => handleFilterChange('status', val)}
          placeholder={t('search.placeholder', 'Selecciona conexión')}
          variant="inverted"
        />
      </div>

      {/* System Status */}
      <div className="space-y-2">
        <Label>{t('table.system_state', 'Estado del sistema')}</Label>
        <MultiSelect
          options={statusOptions}
          value={filters.active}
          onValueChange={(val) => handleFilterChange('active', val)}
          placeholder={t('search.placeholder', 'Selecciona estado')}
          variant="inverted"
        />
      </div>

      {/* Clear Filters Button */}
      <div className="pt-2">
        <Button
          variant="outline"
          className="w-full"
          onClick={clearFilters}
          disabled={!filters.status.length && !filters.active.length}
        >
          {t('filters.clear', 'Limpiar filtros')}
        </Button>
      </div>
    </div>
  );
};
